/**
 * International phone validation and formatting utilities.
 *
 * Uses libphonenumber-js for real per-country validation.
 * Replaces BR-only phone functions from brazilian.ts.
 */
import { parsePhoneNumberFromString, isValidPhoneNumber } from 'libphonenumber-js';

/** Validates an international phone number (any country). */
export const isValidInternationalPhone = (phone: string): boolean => {
  return isValidPhoneNumber(phone);
};

/** Formats phone for display according to its country (e.g. "+55 85 99999-9999"). */
export const formatPhoneDisplay = (phone: string): string => {
  const parsed = parsePhoneNumberFromString(phone);
  if (!parsed) return phone;
  return parsed.formatInternational();
};

/** Formats phone to E.164 for storage/transmission (e.g. "+5585999999999"). */
export const toE164 = (phone: string): string => {
  const parsed = parsePhoneNumberFromString(phone);
  if (!parsed) return phone;
  return parsed.format('E.164');
};
